import BaseStep from "./baseStep";
import ButtonCardList from "../../../ui/button/buttonCard/buttonCardList";
import styles from "./styles.module.scss";
import { ISelectItem, Select } from "../../../ui/select";
import { useState } from "react";
import {
  getFacilityTypes,
  getFacilityTypesConnection,
} from "../../../../lib/utils";
import useFacilityType from "../../../../api/hooks/use-facility-type";
import Loader from "../../../ui/loader";
import { ICounterPage } from "./types";

interface IFacilityTypeStep {
  isNextStepDisabled: boolean;
  data: number[] | null;
  text?: string;
  mode: "default" | "repeat";
  numPage?: number;
  counterPage?: ICounterPage;
  onChange: (selectedId: number) => void;
  onNextStep: () => void;
  onPrevStep: () => void;
}

const FacilityTypeStep = ({
  isNextStepDisabled,
  data,
  text,
  onChange,
  onNextStep,
  onPrevStep,
  mode,
  counterPage,
}: IFacilityTypeStep) => {
  const { facilityTypeList, isLoading } = useFacilityType();

  const [selected, setSelected] = useState<ISelectItem>();

  const handleChange = (itemId: number, option: ISelectItem) => {
    setSelected(option);
  };

  const planFounded =
    data && facilityTypeList?.find((type) => type.id === data[0]);
  const planOption = planFounded && {
    key: planFounded?.id,
    label: planFounded?.fullTitle,
  };

  const transformPlans =
    selected && mode === "default"
      ? getFacilityTypes(selected, data, facilityTypeList, true, onChange)
      : planOption &&
        getFacilityTypesConnection(
          planOption,
          data,
          facilityTypeList,
          onChange
        );

  const textMode = text
    ? text
    : mode === "default"
    ? "Сколько комнат в квартире необходимо?"
    : "Выбирите один из аналогов";

  if (isLoading) {
    return (
      <div className={styles.loader}>
        <Loader />
      </div>
    );
  }

  if (!facilityTypeList.length) {
    return (
      <div className={styles.errorLoadedData}>
        Ошибка загрузке данных попробуйте позже
      </div>
    );
  }

  const menuArray = facilityTypeList
    ?.map((type) => {
      if (!type.fullTitle?.includes("студия")) {
        return {
          key: type.id,
          label: type.fullTitle,
        };
      }
    })
    ?.filter((type) => type !== undefined);

  return (
    <div className={styles.facilityTypeStep}>
      <BaseStep
        counterPage={counterPage}
        nextStep={onNextStep}
        prevStep={onPrevStep}
        text={textMode}
        isNextStepDisabled={isNextStepDisabled}
      >
        <div>
          {!isLoading && menuArray.length && mode === "default" && (
            <div className={styles.facilityTypeStep__select}>
              <Select
                onSelect={handleChange}
                selected={
                  selected
                    ? selected.key
                    : handleChange(-1, menuArray[0] as ISelectItem)
                }
                multiple={false}
                menuArray={menuArray as ISelectItem[]}
              />
            </div>
          )}
          {!isLoading && transformPlans && (
            <div className={styles.facilityTypeStep__children}>
              <ButtonCardList buttons={transformPlans} />
            </div>
          )}
        </div>
      </BaseStep>
    </div>
  );
};

export default FacilityTypeStep;
